import React from 'react';
import { Outlet } from 'react-router';
import Footer from './Footer';
import HomeHeader from './HomeHeader';

function HomeLayout() {
  return (
    <div className="container">
      <HomeHeader />
      <Outlet />
      <Footer />
    </div>
  );
}

export default HomeLayout;
